import React from "react";
import { MainContent, ContentStyled, TitleStyled } from "./styles";
import LogoIcon from "../../assets/tulz-logo-old.png";

const SuccessPage = () => {
  return (
    <MainContent>
      <ContentStyled style={{ marginTop: "6%", marginBottom: 24 }}>
        <TitleStyled>Obrigado pelo seu feedback</TitleStyled>
      </ContentStyled>
      <ContentStyled>
        <img
          src="https://tulz.com.br/nps/static/media/success.aafd7a76509a58695ac6.png"
          alt="sucesso"
        />
      </ContentStyled>
      <ContentStyled style={{ marginTop: "10%" }}>
        <img src={LogoIcon} alt="Logo Tulz" />
      </ContentStyled>
    </MainContent>
  );
};

export default SuccessPage;
